import React from 'react';
import styled from "styled-components";
import {withProps} from "recompose";
import NavLink from 'react-router-dom/NavLink';

import { get, mixin } from "package-common-react/lib/style/util";
import Button from "package-common-react/lib/components/Button";

export const ReplayButton = styled(
  withProps({ primary: true })(Button.withComponent(({backgroundColor, primary, ...props}) => <NavLink {...props} />))
)``;

export const ErrorPanel = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 1;
  height: 100%;
  padding-bottom: 75px;
`;

export const SuccessPanel = ErrorPanel.extend`
`;

export const Heading = styled.h2`
  ${mixin("font.bold", 22, 1.5)};
  color: ${get("color.successText")};
  margin: 0;
  padding: 0;
  text-align: center;
`;

export const Subheading = styled.p`
  ${mixin("font.default", 20)};
  color: ${get("color.blue")};
  margin: 0;
  padding: 0;
  text-align: center;
`;

export const Text = styled.p`
  ${mixin("font.default", 13)};
  color: ${get("color.successText")};
  margin: 0.5em auto;
  padding: 0;
  text-align: center;

  a {
    color: ${get("color.successText")};
    text-decoration: underline;
  }
`;


// WEBPACK FOOTER //
// ./src/components/RegistrationComponents/style.js